export default "__VITE_ASSET__oLGLz90q__"